// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cvowO","newExpiryDate":"styles_newExpiryDate__1fpu1","footer":"styles_footer__2Koy9"};